var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"order-not-ready"},[_c('a-col',{staticClass:"message",attrs:{"span":24}},[_c('span',[_vm._v("La orden no está lista, pedido retrasado en "+_vm._s(_vm.elapsedTime)+" minutos.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }